/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { SelectOptionType, SuccessFetch } from "types";
import { useApi } from "utils";

type Response = {
  payload: string[];
};

export function useReferenceList() {
  // Hooks
  const api = useApi();
  const [data, setData] = useState<string[]>([]);
  const [isLoading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);

    api
      .get("regbydatarange/getreference")
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? [];
        setData(data);
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData([]);
      setLoading(false);
    };
  }, []);

  const getDropdown = (): SelectOptionType[] => {
    // Vars
    const options: SelectOptionType[] = data.map((item) => ({
      value: item, label: item
    }))

    options.unshift({
      label: "All",
      value: ""
    })

    return options
  }

  return {
    data,
    isLoading,
    refetch,
    dropdown: getDropdown(),
  };
}
